import script from "./NewChatMobileOneToOneChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewChatMobileOneToOneChat.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__